const validators = {
  length: {
    labelTemplate: (length, t) =>
      t('#{length} #{type} Long', {
        length: t(humanizeNumber(length, true)),
        type: t(pluralize('Character', length)),
      }),
    validationMsgTemplate: (length, t) =>
      t(`Must be #{length} #{type} or more`, {
        length: t(humanizeNumber(length)),
        type: t(pluralize('сharacter', length)),
      }),
  },
  lower: {
    regexp: /[a-z]/g,
    labelTemplate: (length, t) =>
      t('#{length} Lowercase #{type}', {
        length: t(humanizeNumber(length, true)),
        type: t(pluralize('Letter', length)),
      }),
    validationMsgTemplate: (length, t) =>
      t(`Must be #{length} lowercase #{type} or more`, {
        length: t(humanizeNumber(length)),
        type: t(pluralize('letter', length)),
      }),
  },
  upper: {
    regexp: /[A-Z]/g,
    labelTemplate: (length, t) =>
      t('#{length} Uppercase #{type}', {
        length: t(humanizeNumber(length, true)),
        type: t(pluralize('Letter', length)),
      }),
    validationMsgTemplate: (length, t) =>
      t(`Must be #{length} uppercase #{type} or more`, {
        length: t(humanizeNumber(length)),
        type: t(pluralize('letter', length)),
      }),
  },
  digits: {
    regexp: /[\d]/g,
    labelTemplate: (length, t) =>
      t('#{length} #{type}', {
        length: t(humanizeNumber(length, true)),
        type: t(pluralize('Number', length)),
      }),
    validationMsgTemplate: (length, t) =>
      t(`Must be #{length} #{type} or more`, {
        length: t(humanizeNumber(length)),
        type: t(pluralize('digit', length)),
      }),
  },
  special: {
    regexp: /[!#%$@&^'?"]/g,
    labelTemplate: (length, t) =>
      t(`#{length} Special #{type} !#%$@&^'?"`, {
        length: t(humanizeNumber(length, true)),
        type: t(pluralize('Character', length)),
      }),
    validationMsgTemplate: (length, t) =>
      t(`Must be #{length} special #{type} or more`, {
        length: t(humanizeNumber(length)),
        type: t(pluralize('charter', length)),
      }),
  },
  equals: {
    labelTemplate: t => t('Same Passwords'),
    validationMsgTemplate: t => t('Passwords do not match'),
  },
  required: {
    labelTemplate: t => t('Passwords are required'),
    validationMsgTemplate: t => t('Passwords are required'),
  },
};

export const getPasswordValidatorsByPasswordStrength = (
  passwordStrength,
  t,
) => {
  const {
    minPasswordLength,
    minUppercaseSymbolsCount,
    minLowercaseSymbolsCount,
    minDigitsCount,
    minSpecialSymbolsCount,
  } = passwordStrength;

  return [
    minPasswordLength &&
      buildLengthValidator(validators.length, minPasswordLength, t),
    minUppercaseSymbolsCount &&
      buildSymbolsCountValidator(validators.upper, minUppercaseSymbolsCount, t),
    minLowercaseSymbolsCount &&
      buildSymbolsCountValidator(validators.lower, minLowercaseSymbolsCount, t),
    minDigitsCount &&
      buildSymbolsCountValidator(validators.digits, minDigitsCount, t),
    minSpecialSymbolsCount &&
      buildSymbolsCountValidator(validators.special, minSpecialSymbolsCount, t),
    cookConfirmationFieldValidator(buildEqualsValidator(validators.equals, t)),
  ].filter(item => !!item);
};

function cookConfirmationFieldValidator(validator) {
  validator._confirmationFieldValidator = true;
  return validator;
}
export function isConfirmationFieldValidator(validator) {
  return !!validator._confirmationFieldValidator;
}

function buildLengthValidator(validator, length = 0, t) {
  return {
    validator: buildMinLengthValidator(validator, length, t),
    label: validator.labelTemplate(length, t),
  };
}
function buildSymbolsCountValidator(validator, length = 0, t) {
  return {
    validator: buildRegexpValidator(validator, length, t),
    label: validator.labelTemplate(length, t),
  };
}
function buildEqualsValidator(validator, t) {
  return {
    validator: samePasswordConfirmationValidator(validator, t),
    label: validator.labelTemplate(t),
    groupPriority: 2,
  };
}

const buildMinLengthValidator = (validator, min, t) => password =>
  !password || password.length < min
    ? validator.validationMsgTemplate(min, t)
    : undefined;

const buildRegexpValidator = (validator, min = 0, t) => password => {
  const { regexp } = validator;
  return !password || (password.match(regexp) || []).length < min
    ? validator.validationMsgTemplate(min, t)
    : undefined;
};

const samePasswordConfirmationValidator = (validator, t) => (
  password,
  passwordConfirmation,
) =>
  password === '' || password !== passwordConfirmation
    ? validator.validationMsgTemplate(t)
    : undefined;

function pluralize(string, length) {
  return length > 1 ? `${string}s` : string;
}
function humanizeNumber(number, capital = false) {
  if (number === 1) {
    return capital ? `One` : 'one';
  }
  return number;
}
